import { SWAGGERHUB_ROLE } from '~/shared/types/shub'

export const isAtLeastDesigner = (role?: SWAGGERHUB_ROLE | string) => role?.toLowerCase() === SWAGGERHUB_ROLE.DESIGNER || role?.toLowerCase() === SWAGGERHUB_ROLE.OWNER

export const isAtLeastConsumer = (role?: SWAGGERHUB_ROLE | string) => role?.toLowerCase() === SWAGGERHUB_ROLE.CONSUMER || role?.toLowerCase() === SWAGGERHUB_ROLE.DESIGNER || role?.toLowerCase() === SWAGGERHUB_ROLE.OWNER
